import React, { useEffect, useState } from "react";
import "../styles/app.css";
import HeroCarousel from "../components/HeroCarousel";
import useHomeData from "../Hooks/useHome";
import WhatsNewSlider from "../components/WhatsNewSlider";
import { useSelector } from "react-redux";
import ShopByCategory from "../components/ShopByCategory";
import TrendingSection from "../components/Trending";
import MoreToExplore from "../components/MoreToExplore";
import { useMediaQuery } from "react-responsive";
import WhatsAppButton from "../components/WhatsappIcon";

const Home = () => {
  const [homeData, setHomeData] = useState(null);
  const { data, loading, error } = useSelector((state) => state.api);
  const { getHomeData } = useHomeData();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    const fetchData = async () => {
      const data = await getHomeData();
      setHomeData(data);
    };
    fetchData();
  }, []);

  if (loading) return <p></p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="home" style={{ minHeight: "100vh" }}>
      <HeroCarousel data={data?.Hero_Section} />
      <WhatsNewSlider items={homeData?.whats_new} />
      <ShopByCategory isMobile={isMobile} categories={homeData?.shop_by_category} />
      <TrendingSection isMobile={isMobile} categories={homeData?.trending} />
      <MoreToExplore isMobile={isMobile} categories={homeData?.more_to_explore} />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
